module.exports = __webpack_public_path__ + "img/tesouro.bb4c2462.jpg";